export default {
  title: 'Die Küche hat deine Bestellung erhalten',
  description: 'Denk daran, deinen Rechnung zu schließen und am Ende deines Besuches zu bezahlen.',
  buttons: {
    okay: 'Okay',
  },
};
